import { HttpClient, PaginatedResponse, robotoHeaders } from "../../http";

import { ImageRegistryRecord } from "./ImageRegistryRecord";

export class ImageRegistryService {
  #httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.#httpClient = httpClient;
  }

  public async getImagesForRepository(
    repository: string | null,
    options: Partial<{
      abortSignal: AbortSignal;
      orgId: string;
    }>,
  ): Promise<PaginatedResponse<ImageRegistryRecord>> {
    if (!options.orgId) {
      throw Error(
        "getImagesForRepository requires an Org ID, none was provided",
      );
    }

    const searchParams = new URLSearchParams();
    if (repository) {
      searchParams.append("repository_name", repository);
    }

    const url = this.#httpClient.constructUrl(
      `v1/images/image/record/list`,
      searchParams,
    );

    const response = await this.#httpClient.get(url, {
      signal: options?.abortSignal,
      headers: robotoHeaders({ orgId: options.orgId }),
    });

    return await response.json<PaginatedResponse<ImageRegistryRecord>>();
  }
}
